import { createUseStyles } from 'react-jss'
import colorsV2 from 'src/config/colorsV2'

export default createUseStyles({
  root: {
    position: 'relative',
    width: 24,
    height: 24,
    overflow: 'hidden',
    '&$small': {
      width: 20,
      height: 20,
    },

    '& .flagIcon': {
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      lineHeight: '1em',
    },

    '& > span': {
      boxSizing: 'border-box',
      borderRadius: '50%',
      backgroundSize: 'cover',
      backgroundPosition: 'bottom',
      width: '100%',
      height: '100%',
      display: 'inline-block',
      border: `1px solid ${colorsV2.lightBorder}`,
    },

    '& > div': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: -1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  small: {},
})
